// extracted by mini-css-extract-plugin
export default {"shareLink":"jzGbO","shareLinkInput":"jOGG4","wrapper":"PpCfY","buttonsWrapper":"ATbpX","buttons":"o0nIT","shareLinkCopied":"NbraH","shareLinkCopiedHidden":"XWsIH"};